/** How long a hash target is kept in view while the page above it settles. */
const SETTLE_MS = 2000

const STOP_EVENTS = ['wheel', 'touchstart', 'pointerdown', 'keydown'] as const

/**
 * Scroll `element` into view (below the sticky header, see `scroll-padding-top`) and keep it
 * there while the page above it still grows, e.g. Settings cards that load their data after
 * /settings/time-off#time-off opened. Stops when the user scrolls, taps, clicks or types, or after 2 s.
 * Returns a cleanup function.
 */
export function keepInView(element: HTMLElement): () => void {
  let active = true
  let timer: ReturnType<typeof setTimeout> | undefined
  const scroll = () => {
    if (active) element.scrollIntoView({ block: 'start' })
  }
  const observer = new ResizeObserver(scroll)
  const stop = () => {
    active = false
    observer.disconnect()
    clearTimeout(timer)
    for (const type of STOP_EVENTS) window.removeEventListener(type, stop, true)
  }
  timer = setTimeout(stop, SETTLE_MS)
  for (const type of STOP_EVENTS) {
    window.addEventListener(type, stop, { capture: true, passive: true })
  }
  observer.observe(document.body)
  scroll()
  return stop
}
